// Mirror of the server-side product catalog. Used only for rendering;
// the backend re-validates package_id and pricing.
// `bonus` = extra free GB shown next to the All-In DEAL label.
// `perMonth` = per-month price shown as small helper text under total price.
// `prefixKey` = i18n key prepended to the label at render time (for 3m/6m tabs).

export const ALLIN_PRODUCTS = [
  { id: "allin-1gb", label: "All-In 1GB-DEAL", sub: "50MIN \u00b7 5SMS", price: 4.95, bonus: 0 },
  { id: "allin-2gb", label: "All-In 2GB-DEAL", sub: "100MIN \u00b7 10SMS", price: 5.95, bonus: 1 },
  { id: "allin-4gb", label: "All-In 4GB-DEAL", sub: "100MIN \u00b7 10SMS", price: 7.95, popular: true, bonus: 1 },
  { id: "allin-8gb", label: "All-In 8GB-DEAL", sub: "200MIN \u00b7 20SMS", price: 9.95, bonus: 1 },
  { id: "allin-16gb", label: "All-In 16GB-DEAL", sub: "200MIN \u00b7 20SMS", price: 14.95, popular: true, bonus: 3 },
  { id: "allin-32gb", label: "All-In 32GB-DEAL", sub: "300MIN \u00b7 30SMS", price: 19.95, bonus: 5 },
  { id: "allin-64gb", label: "All-In 64GB-DEAL", sub: "400MIN \u00b7 40SMS", price: 24.95, popular: true, bonus: 5 },
  { id: "allin-128gb", label: "All-In 128GB-DEAL", sub: "500MIN \u00b7 50SMS", price: 29.95, bonus: 10 },
  { id: "allin-256gb", label: "All-In 256GB-DEAL", sub: "600MIN \u00b7 60SMS", price: 34.95, popular: true, bonus: 10 },
  { id: "allin-512gb", label: "All-In 512GB-DEAL", sub: "750MIN \u00b7 75SMS", price: 49.95, bonus: 10 },
];

export const DATA_PRODUCTS = [
  { id: "data-5gb", label: "DATA Only 5GB", sub: "", price: 7.5 },
  { id: "data-10gb", label: "DATA Only 10GB", sub: "10MIN \u00b7 1SMS", price: 10 },
  { id: "data-15gb", label: "DATA Only 15GB", sub: "15MIN \u00b7 2SMS", price: 12.5 },
  { id: "data-20gb", label: "DATA Only 20GB", sub: "20MIN \u00b7 2SMS", price: 15 },
  { id: "data-50gb", label: "DATA Only 50GB", sub: "50MIN \u00b7 5SMS", price: 19.99 },
  { id: "data-100gb", label: "DATA Only 100GB", sub: "100MIN \u00b7 10SMS", price: 24.99, popular: true },
  { id: "data-200gb", label: "DATA Only 200GB", sub: "200MIN \u00b7 20SMS", price: 29.99 },
  { id: "data-300gb", label: "DATA Only 300GB", sub: "300MIN \u00b7 30SMS", price: 34.99, popular: true },
  { id: "data-400gb", label: "DATA Only 400GB", sub: "400MIN \u00b7 40SMS", price: 39.99 },
  { id: "data-500gb", label: "DATA Only 500GB", sub: "500MIN \u00b7 50SMS", price: 44.99 },
];

export const CREDIT_PRODUCTS = [
  { id: "credit-5", label: "Credit \u20ac5", sub: "", price: 5 },
  { id: "credit-10", label: "Credit \u20ac10", sub: "", price: 10 },
  { id: "credit-20", label: "Credit \u20ac20", sub: "", price: 20 },
  { id: "credit-50", label: "Credit \u20ac50", sub: "", price: 50 },
];

// Tab 1 = existing single-month landing (unchanged)
export const ALL_PRODUCTS_GROUPED = [
  { labelKey: "tabAllIn", items: ALLIN_PRODUCTS },
  { labelKey: "tabData", items: DATA_PRODUCTS, subtitleKey: "dataPromo" },
  { labelKey: "tabCredit", items: CREDIT_PRODUCTS, subtitleKey: "creditPromo" },
];

// Tab 2 = 3 Maanden Deal. Labels use prefixKey for i18n rendering.
export const MONTHS3_PRODUCTS = [
  { id: "3m-5gb",   prefixKey: "months3Prefix", label: "5GB-DEAL",   sub: "50MIN \u00b7 5SMS",    price: 18.00, perMonth: 6.00 },
  { id: "3m-10gb",  prefixKey: "months3Prefix", label: "10GB-DEAL",  sub: "100MIN \u00b7 10SMS",  price: 25.50, perMonth: 8.50 },
  { id: "3m-15gb",  prefixKey: "months3Prefix", label: "15GB-DEAL",  sub: "100MIN \u00b7 10SMS",  price: 27.00, perMonth: 9.00 },
  { id: "3m-20gb",  prefixKey: "months3Prefix", label: "20GB-DEAL",  sub: "100MIN \u00b7 10SMS",  price: 33.00, perMonth: 11.00 },
  { id: "3m-50gb",  prefixKey: "months3Prefix", label: "50GB-DEAL",  sub: "100MIN \u00b7 10SMS",  price: 52.50, perMonth: 17.50 },
  { id: "3m-100gb", prefixKey: "months3Prefix", label: "100GB-DEAL", sub: "100MIN \u00b7 10SMS",  price: 60.00, perMonth: 20.00 },
  { id: "3m-150gb", prefixKey: "months3Prefix", label: "150GB-DEAL", sub: "150MIN \u00b7 10SMS",  price: 67.50, perMonth: 22.50, popular: true },
  { id: "3m-200gb", prefixKey: "months3Prefix", label: "200GB-DEAL", sub: "200MIN \u00b7 10SMS",  price: 75.00, perMonth: 25.00, popular: true },
  { id: "3m-250gb", prefixKey: "months3Prefix", label: "250GB-DEAL", sub: "250MIN \u00b7 10SMS",  price: 82.50, perMonth: 27.50 },
];

// Tab 3 = 6 Maanden Deal. Labels use prefixKey for i18n rendering.
export const MONTHS6_PRODUCTS = [
  { id: "6m-5gb",   prefixKey: "months6Prefix", label: "5GB-DEAL",   sub: "50MIN \u00b7 5SMS",    price: 30.00, perMonth: 5.00 },
  { id: "6m-10gb",  prefixKey: "months6Prefix", label: "10GB-DEAL",  sub: "100MIN \u00b7 10SMS",  price: 45.00, perMonth: 7.50 },
  { id: "6m-15gb",  prefixKey: "months6Prefix", label: "15GB-DEAL",  sub: "100MIN \u00b7 10SMS",  price: 60.00, perMonth: 10.00 },
  { id: "6m-20gb",  prefixKey: "months6Prefix", label: "20GB-DEAL",  sub: "100MIN \u00b7 10SMS",  price: 75.00, perMonth: 12.50 },
  { id: "6m-50gb",  prefixKey: "months6Prefix", label: "50GB-DEAL",  sub: "100MIN \u00b7 10SMS",  price: 90.00, perMonth: 15.00 },
  { id: "6m-100gb", prefixKey: "months6Prefix", label: "100GB-DEAL", sub: "100MIN \u00b7 10SMS",  price: 105.00, perMonth: 17.50 },
  { id: "6m-150gb", prefixKey: "months6Prefix", label: "150GB-DEAL", sub: "150MIN \u00b7 10SMS",  price: 120.00, perMonth: 20.00, popular: true },
  { id: "6m-200gb", prefixKey: "months6Prefix", label: "200GB-DEAL", sub: "200MIN \u00b7 10SMS",  price: 135.00, perMonth: 22.50, popular: true },
  { id: "6m-250gb", prefixKey: "months6Prefix", label: "250GB-DEAL", sub: "250MIN \u00b7 10SMS",  price: 150.00, perMonth: 25.00 },
];
